import { trans } from '@spotahome/soyuz/client';
import { Mediator } from '@spotahome/soyuz-mediator';
import { CHANNELS } from '@spotahome/ui-library/src/tenant/components/utils/constants';

const InstantBookingLabelDescription = () => {
  const handleOnClick = e => {
    e.preventDefault();
    Mediator.publish(CHANNELS.OPEN_INSTANT_BOOKING_MODAL);
  };

  return (
    <div
      role="button"
      tabIndex={-1}
      onClick={handleOnClick}
      dangerouslySetInnerHTML={{
        __html: trans('listing.labels.instantBooking.description')
      }}
    />
  );
};

export default InstantBookingLabelDescription;
